import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import api from "@/lib/api";

const STEPS = [
  { element: "[data-testid='portfolio-page']", popover: { title: "1 · Il tuo portafoglio", description: "Qui trovi tutte le aziende che segui, con quanto manca e lo stato dell'invio. È il punto di partenza di ogni giornata." } },
  { element: "[data-testid='next-steps-panel']", popover: { title: "2 · Prossimi passi", description: "Le azioni da fare, in ordine di importanza, per ogni azienda. Clicca su un'azione per andare subito al punto giusto." } },
  { element: "[data-testid='sidebar-company-select']", popover: { title: "3 · Scegli l'azienda", description: "Seleziona qui l'azienda su cui lavorare: il menu 'Azienda selezionata' mostrerà anagrafica, periodi e questionari di quella azienda." } },
  { element: "[data-testid='nav-attivita']", popover: { title: "4 · Attività di revisione", description: "Quando l'azienda invia la compilazione, qui controlli le incongruenze, commenti i campi e approvi." } },
  { element: "[data-testid='nav-pmi-banche']", popover: { title: "5 · Dialogo PMI – Banche", description: "Il questionario MEF che le banche usano per valutare la sostenibilità. Inizia dagli indicatori di Priorità 1." } },
  { element: "[data-testid='nav-group-aziendaSelezionata']", popover: { title: "6 · Azienda selezionata", description: "Anagrafica, periodi di rendicontazione, questionario ESG e documenti dell'azienda scelta. Apri sempre il periodo giusto prima di inserire dati." } },
  { element: "[data-testid='user-menu-button']", popover: { title: "7 · Il tuo menu", description: "Da qui puoi rivedere questo tour in qualsiasi momento, cambiare contesto e aprire le impostazioni." } },
];

const visible = (sel) => { const el = document.querySelector(sel); return el && el.offsetParent !== null; };

export function useConsultantTour({ autoStart, enabled }) {
  const navigate = useNavigate();
  const start = useCallback(() => {
    const steps = STEPS.filter((s) => visible(s.element));
    if (!steps.length) return;
    driver({
      showProgress: true, allowClose: true, nextBtnText: "Avanti", prevBtnText: "Indietro", doneBtnText: "Fine",
      progressText: "{{current}} di {{total}}", steps,
      onDestroyed: () => { api.post("/consultant/tour", { completed: true }).catch(() => {}); },
    }).drive();
  }, []);
  useEffect(() => {
    if (!autoStart || !enabled) return;
    api.get("/consultant/tour").then((r) => {
      if (!r.data.completed) setTimeout(start, 1200);
    }).catch(() => {});
  }, [autoStart, enabled, start]);
  return { start, goPortfolioAndStart: () => { navigate("/portafoglio"); setTimeout(start, 1200); } };
}
